import Flickity from "./flickityCarousel.js";
new Flickity();